/* Santas Vault - personalisation cart writer.
   ------------------------------------------------------------------
   WHY THIS FILE EXISTS, AND THE BUG IT REPLACES.

   The first version set the form quantity to N and wrote
   properties[Item 1 name], properties[Item 2 name] ... onto ONE line item.
   That is wrong in a way that only shows up after money changes hands:

     * the packing slip reads "Qty 3" with three names buried in properties,
       so a picker prints three of whatever they read first;
     * if the customer edits the quantity in the cart from 3 to 2, the
       properties still carry three names and nothing reconciles them;
     * every unit on the line shares one variant, so three people cannot
       have three sizes.

   A personalised line item must be one unit, one name. So this file
   intercepts the add, and posts N separate lines to /cart/add.js, each
   quantity 1, each with its own variant and its own properties[Name].
   Identical name + identical variant merge naturally, which is correct.

   Horizon integration: we take the submit in the CAPTURE phase and
   stopImmediatePropagation so product-form.js never sees it, then dispatch
   the theme's own 'shopify:cart:lines-update' event afterwards so the cart
   drawer opens and refreshes exactly as it would have.
*/
(function () {
  var EVT = 'shopify:cart:lines-update';

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  function root() { return $('.sv-perso'); }

  function cfg() {
    var el = root();
    if (!el) return null;
    var raw = $('#sv-variants');
    var data = { variants: [], options: [] };
    if (raw) { try { data = JSON.parse(raw.textContent); } catch (e) {} }
    return {
      el: el,
      mode: el.getAttribute('data-mode') || 'design',
      maxc: parseInt(el.getAttribute('data-maxc'), 10) || 14,
      required: el.getAttribute('data-required') !== 'false',
      variants: data.variants || [],
      options: data.options || [],
      slot: el.getAttribute('data-slot') || 'hero',
      // The print AREA, not just the slot. A circular area composes the name
      // INSIDE the disc; the flat areas put it under the artwork. Without this
      // the ornament preview showed the artwork in a circle with the name
      // sitting below the circle, while the press prints both inside it - and
      // the copy under the preview promises it is what gets printed.
      area: el.getAttribute('data-area') || '',
      ink: el.getAttribute('data-ink') || '#0E2B22',
      font: el.getAttribute('data-font') || 'Luckiest Guy',
      art: el.getAttribute('data-art') || '',
      handle: el.getAttribute('data-handle') || '',
      index: el.getAttribute('data-designs') || '',
      band: bandCfg()
    };
  }

  /* ---------- the bandana preview ----------
     A bandana's preview used to be the bare artwork on cream. It never moved when
     the shopper picked a colour or a style, under a caption promising that what
     they see is what gets printed. It now shows the PHOTOGRAPH of the variant
     they chose. Those photographs carry the printed "YOUR NAME", so the blank of
     that colour and style is laid over that one band and the typed name is drawn
     in its place. Both boxes were MEASURED by differencing a design mockup
     against its blank, not guessed. */
  var _band;
  function bandCfg() {
    if (_band !== undefined) return _band;
    var el = document.getElementById('sv-bandana');
    _band = null;
    if (el) { try { _band = JSON.parse(el.textContent); } catch (e) { _band = null; } }
    return _band;
  }

  // Style and colour come off the variant's own option values, so nothing has to
  // be kept in step by hand when a colour is added or a size retired.
  function bandFor(c, vid, vars) {
    if (!c || !c.band) return null;
    var v = (vars || c.variants).filter(function (x) { return String(x.id) === String(vid); })[0];
    if (!v) return null;
    var names = (c.options || []).map(function (o) { return (o.name || o) + ''; });
    var ci = names.indexOf('Bandana colour');
    var si = names.indexOf('Style and size');
    var col = (ci >= 0 ? v.options[ci] : 'Red') || 'Red';
    var sty = (si >= 0 ? v.options[si] : '') || '';
    var tag = /^collar/i.test(sty) ? 'collar' : 'tie';
    var slug = col.toLowerCase().replace(/[^a-z]/g, '');
    var blank = (c.band.blanks[tag] || {})[slug];
    var cal = c.band.calib[tag];
    if (!blank || !cal) return null;
    return { shot: v.img || '', blank: blank, cal: cal, colour: col, tag: tag };
  }

  /* ---------- the lettering the customer chooses ----------
     Four faces, all already loaded by the personalisation snippet and all SIL
     Open Font Licence, so there is nothing to buy and nothing to attribute.

     THE SCRIPT CAVEAT IS SHOWN, NOT HIDDEN. Great Vibes is the one people reach
     for and the one that suffers most at small sizes: thinner strokes, wider
     letters, joins that fill in. Rather than removing it from the small print
     areas, the note under the row says so and the preview draws the real
     thing, so the choice is informed rather than prevented. */
  var FACES = [
    { key: 'Bold',   css: 'Luckiest Guy', caps: true },
    { key: 'Comic',  css: 'Bangers',      caps: true },
    { key: 'Script', css: 'Great Vibes',     caps: false },
    { key: 'Clean',  css: 'Baloo 2',      caps: false }
  ];

  function faceFor(node) {
    var r = node && node.querySelector('.sv-face input:checked');
    var key = r ? r.value : null;
    for (var i = 0; i < FACES.length; i++) {
      if (FACES[i].key === key) return FACES[i];
    }
    return null;
  }

  function faceRow(i, dflt, noNote) {
    var h = '<div class="sv-facewrap"><span class="sv-perso__lab">Lettering</span>' +
            '<div class="sv-face" role="radiogroup" aria-label="Lettering style">';
    for (var n = 0; n < FACES.length; n++) {
      var f = FACES[n];
      var on = (f.css === dflt) || (n === 0 && !dflt);
      h += '<label class="sv-face__opt"' +
           ' style="font-family:&quot;' + f.css + '&quot;,cursive">' +
           '<input type="radio" name="sv-face-' + i + '" value="' + f.key + '"' +
           (on ? ' checked' : '') + '>' +
           '<span>' + (f.caps ? f.key.toUpperCase() : f.key) + '</span></label>';
    }
    // The Script note once per order, not once per person: four copies of the same caveat was a screen of reading.
    h += '</div>' + (noNote ? '' : '<p class="sv-face__note">Script is lower case and flowing. It is ' +
         'the prettiest at full size and the hardest to read on the small items, ' +
         'so check the preview.</p>') + '</div>';
    return h;
  }

  /* ---------- variant resolution ---------- */

  function currentVariantId() {
    var f = form();
    var i = f && f.querySelector('input[name="id"], select[name="id"]');
    if (i && i.value) return String(i.value);
    var c = cfg();
    var a = c && c.variants.filter(function (v) { return v.available; })[0];
    return a ? String(a.id) : (c && c.variants[0] ? String(c.variants[0].id) : '');
  }

  function currentOptions() {
    var c = cfg(); if (!c) return [];
    var id = currentVariantId();
    var v = c.variants.filter(function (x) { return String(x.id) === id; })[0];
    return v ? v.options.slice() : (c.variants[0] ? c.variants[0].options.slice() : []);
  }

  function resolve(opts, vars) {
    var c = cfg(); if (!c) return null;
    var hit = (vars || c.variants).filter(function (v) {
      return v.options.length === opts.length && v.options.every(function (o, i) { return o === opts[i]; });
    })[0];
    return hit || null;
  }

  /* ---------- item rows ---------- */

  function optionSelects(idx, chosen, vars) {
    var c = cfg(); if (!c || !c.options.length) return '';
    var list = vars || c.variants;
    return c.options.map(function (o, oi) {
      var vals = o.values.map(function (val) {
        var sel = (chosen[oi] === val) ? ' selected' : '';
        /* SOLD OUT IS SHOWN, NOT OFFERED. This second row of selects used to
           offer unbuyable values as live, so the shopper found out only when
           the add to cart failed. A value is unbuyable when NO available
           variant carries it at this option's position; the old test was
           limited to one-option products and so would have gone silent the
           moment the bandana gained a colour. */
        var out = !list.some(function (v) {
          return v.options[oi] === val && v.available;
        });
        return '<option value="' + esc(val) + '"' + sel + (out ? ' disabled' : '') + '>' +
               esc(val) + (out ? ' (sold out)' : '') + '</option>';
      }).join('');
      return '<div class="sv-optcell"><label class="sv-perso__lab">' + esc(o.name) + '</label>' +
             '<select class="sv-select sv-opt" data-oi="' + oi + '">' + vals + '</select></div>';
    }).join('');
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (m) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[m];
    });
  }

  /* ---------- FAMILY SETS: a different design for each person (store 0.34.0) ----------
     Tony, 24 Sep 2026: "They can be individually made items but buy in qty sets so maybe just a discounted
     product qty selected at design point ... Mum dad bro sis all with a different name and design".

     Every design is its own Shopify product, so a row with another design is simply a line for THAT product:
     its own variant, its own print file, its own tracking. Nothing is bundled and nothing new is discounted;
     the multi-buy automatic discounts (window.SV_MB, written by sv-multibuy.liquid, the one place the tiers
     live in the theme) price the lot at the cart. This block only lets each row carry its own design and
     shows the shopper the saving while they choose. */
  var IDX = null, IDXP = null, PROD = {};
  function tiers() { return (window.SV_MB || []).slice().sort(function (a, b) { return a[0] - b[0]; }); }
  function pctFor(n) { var p = 0; tiers().forEach(function (t) { if (n >= t[0]) p = t[1]; }); return p; }
  function nextTier(n) { var t = tiers(); for (var i = 0; i < t.length; i++) if (t[i][0] > n) return t[i]; return null; }
  function money(c) { return '$' + (c / 100).toFixed(2); }
  // The checkout allocates a percentage per line and rounds half up; this matches it to the cent.
  function lineAfter(c, pct) { return Math.round(c * (100 - pct) / 100); }

  var CDN = 'https://cdn.shopify.com/s/files/1/0763/0274/5766/files/';
  function img(u, w) {
    if (!u) return '';
    if (u.indexOf('//') === 0) u = 'https:' + u;
    else if (u.indexOf('http') !== 0) u = CDN + u;
    u = u.replace(/_(\d+x\d*|\d*x\d+)(?=\.(jpe?g|png|webp|gif)(\?|$))/i, '');
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function loadIndex() {
    var c = cfg();
    if (IDXP) return IDXP;
    if (!c || !c.index || !c.handle) return (IDXP = Promise.resolve(null));
    IDXP = fetch(c.index).then(function (r) { if (!r.ok) throw 0; return r.json(); }).then(function (j) {
      if (j && j.cdn) CDN = j.cdn;
      var kind = null, mine = null;
      (j.designs || []).some(function (d) {
        return (d[4] || '').split('').some(function (k) {
          if (handleFor(d, k, j) === c.handle) { kind = k; mine = d; return true; }
          return false;
        });
      });
      IDX = kind ? { j: j, kind: kind, mine: mine } : null;
      return IDX;
    }).catch(function () { IDX = null; return null; });
    return IDXP;
  }
  function handleFor(d, k, j) { return (d[6] && d[6][k]) || (d[5] + ((j || IDX.j).sfx[k] || '')); }
  function fetchProduct(h) {
    if (PROD[h]) return PROD[h];
    return (PROD[h] = fetch('/products/' + h + '.js').then(function (r) { if (!r.ok) throw 0; return r.json(); })
      .then(function (p) {
        return {
          handle: h,
          variants: (p.variants || []).map(function (v) {
            return { id: v.id, available: v.available, options: v.options, price: v.price,
                     img: v.featured_image && v.featured_image.src ? v.featured_image.src : '' };
          })
        };
      }));
  }
  // The row's own variants: the page's, until the shopper gives this row another design.
  function rowVars(node) { var c = cfg(); return (node && node.__prod && node.__prod.variants) || (c ? c.variants : []); }
  function rowPrice(node) {
    var id = rowVariantId(node);
    var v = rowVars(node).filter(function (x) { return String(x.id) === String(id); })[0];
    return v ? v.price : 0;
  }
  function rowArt(node) {
    var c = cfg();
    return node && node.__d ? img(node.__d[7] || node.__d[3], 900) : (c ? c.art : '');
  }
  function rowInk(node) { var c = cfg(); return (node && node.__d && node.__d[9]) || (c ? c.ink : '#0E2B22'); }
  function rowSlot(node) {
    var c = cfg();
    if (IDX && IDX.kind === 'c') return 'above';   // the stocking prints the name across the top
    return (node && node.__d && node.__d[8]) || (c ? c.slot : 'hero');
  }

  function headHtml(i, qty, d) {
    var name = d ? d[1] : '';
    return '<div class="sv-item__head">' +
      '<span class="sv-item__n">Item ' + i + '</span>' +
      '<span class="sv-item__design" data-design-slot>' +
        (d ? '<img src="' + esc(img(d[7] || d[3], 120)) + '" alt="" width="40" height="40">' : '') +
        '<span class="sv-item__dname">' + esc(name) + '</span>' +
        '<button type="button" class="sv-item__chg" data-chg="' + i + '"' + (IDX ? '' : ' hidden') + ' aria-label="Change the design for item ' + i + '">Change</button>' +
      '</span>' +
      (i > 1 ? '<button type="button" class="sv-item__copy" data-copy="' + i + '" aria-label="Same design, options and lettering as item 1">Copy item 1</button>' : '') +
    '</div>' +
    '<div class="sv-dpick" hidden></div>';
  }

  function refreshHead(node) {
    var slot = node.querySelector('[data-design-slot]');
    if (!slot) return;
    var d = node.__d || (IDX && IDX.mine);
    var im = slot.querySelector('img');
    if (d) {
      if (!im) { im = document.createElement('img'); im.width = 40; im.height = 40; im.alt = ''; slot.insertBefore(im, slot.firstChild); }
      im.src = img(d[7] || d[3], 120);   // the cut-out reads at 40 px; the white-ground mockup did not
    }
    slot.querySelector('.sv-item__dname').textContent = d ? d[1] : '';
    var b = slot.querySelector('.sv-item__chg'); if (b) b.hidden = !IDX;
  }

  // Swap one row to another design: fetch that design's product, carry the row's choices across, redraw.
  function setRowDesign(node, d) {
    if (!IDX || !d) return Promise.resolve();
    var mine = IDX.mine && d[0] === IDX.mine[0];
    var keepOpts = $$('.sv-opt', node).map(function (s) { return s.value; });
    var done = function (prod) {
      node.__d = mine ? null : d;
      node.__prod = mine ? null : prod;
      var wrap = node.querySelector('.sv-optwrap');
      if (wrap) {
        var list = rowVars(node);
        var pick = resolve(keepOpts, list) ? keepOpts : (list.filter(function (v) { return v.available; })[0] || list[0] || {}).options || keepOpts;
        wrap.innerHTML = optionSelects(node.getAttribute('data-idx'), pick, list);
      }
      var art = node.querySelector('.sv-preview2__art');
      if (art) art.src = rowArt(node);
      var stage = node.querySelector('.sv-preview2__stage');
      if (stage) stage.setAttribute('data-slot', rowSlot(node));
      node.__partner = null;
      if (!mine && (IDX.kind === 's' || IDX.kind === 'c')) {
        var pk = IDX.kind === 's' ? 'c' : 's';
        if ((d[4] || '').indexOf(pk) >= 0) {
          node.__partnerP = fetchProduct(handleFor(d, pk)).then(function (pp) {
            var pv = pp.variants.filter(function (v) { return v.available; })[0];
            node.__partner = pv ? String(pv.id) : null;
          }).catch(function () { node.__partner = null; });
        }
      }
      refreshHead(node);
      sync(node);
      summary();
    };
    if (mine) { done(null); return Promise.resolve(); }
    node.classList.add('is-loading');
    return fetchProduct(handleFor(d, IDX.kind)).then(function (prod) {
      node.classList.remove('is-loading'); done(prod);
    }).catch(function () {
      node.classList.remove('is-loading');
      var e = node.querySelector('.sv-err');
      if (e) { e.textContent = 'That design could not be loaded. Try another.'; e.hidden = false; }
    });
  }

  // The picker: this product type's designs, the page's own theme first, 24 at a time, with a search.
  function openPicker(node) {
    var box = node.querySelector('.sv-dpick'); if (!box || !IDX) return;
    if (!box.hidden) { box.hidden = true; return; }
    $$('.sv-dpick').forEach(function (b) { b.hidden = true; });
    var all = IDX.j.designs.filter(function (d) { return (d[4] || '').indexOf(IDX.kind) >= 0; });
    var th = IDX.mine ? IDX.mine[2] : '';
    all.sort(function (a, b) { return (a[2] === th ? 0 : 1) - (b[2] === th ? 0 : 1); });
    var cur = (node.__d || IDX.mine || [])[0];
    var shown = 24, q = '';
    box.innerHTML = '<div class="sv-dpick__top"><input type="search" class="sv-dpick__q" placeholder="Search ' + all.length +
      ' designs, e.g. dog, surf, reindeer" aria-label="Search designs"><button type="button" class="sv-dpick__x" aria-label="Close">Close</button></div>' +
      '<div class="sv-dpick__grid" role="listbox" aria-label="Designs"></div><button type="button" class="sv-dpick__more" hidden>Show more designs</button>';
    var grid = box.querySelector('.sv-dpick__grid'), more = box.querySelector('.sv-dpick__more');
    function list() {
      if (!q) return all;
      var w = q.toLowerCase();
      return all.filter(function (d) { return (d[1] + ' ' + d[2] + ' ' + (d[10] || '') + ' ' + (d[11] || '')).toLowerCase().indexOf(w) >= 0; });
    }
    function draw() {
      var l = list();
      grid.innerHTML = l.slice(0, shown).map(function (d) {
        return '<button type="button" class="sv-dpick__t' + (d[0] === cur ? ' is-on' : '') + '" data-d="' + esc(d[0]) +
          '" title="' + esc(d[1]) + '" role="option" aria-selected="' + (d[0] === cur) + '"><img src="' + esc(img(d[3], 160)) +
          '" alt="' + esc(d[1]) + '" loading="lazy" width="160" height="160"><span>' + esc(d[1]) + '</span></button>';
      }).join('') || '<p class="sv-dpick__none">No designs match that. Try another word.</p>';
      more.hidden = l.length <= shown;
    }
    box.querySelector('.sv-dpick__q').addEventListener('input', function (e) { q = e.target.value.trim(); shown = 24; draw(); });
    box.querySelector('.sv-dpick__x').addEventListener('click', function () { box.hidden = true; });
    more.addEventListener('click', function () { shown += 24; draw(); });
    grid.addEventListener('click', function (e) {
      var t = e.target.closest('.sv-dpick__t'); if (!t) return;
      var d = all.filter(function (x) { return x[0] === t.getAttribute('data-d'); })[0];
      box.hidden = true;
      setRowDesign(node, d).then(function () {
        node.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      });
    });
    draw();
    box.hidden = false;
  }

  // The saving, on the number buttons and in one line under them.
  function labelQty() {
    var t = tiers(); if (!t.length) return;
    $$('.sv-qty__b').forEach(function (b) {
      var n = parseInt(b.getAttribute('data-q'), 10) || 1, p = pctFor(n);
      var sm = b.querySelector('small');
      if (!p) { if (sm) sm.remove(); return; }
      if (!sm) { sm = document.createElement('small'); b.appendChild(sm); b.insertBefore(document.createTextNode(' '), sm); }
      sm.textContent = p + '% off';
      // fixloop 1014 (axe label-content-name-mismatch, serious): the name must contain the visible text, "2 10% off".
      // It was "2 items, 10% off each", which voice control users cannot say. The group is labelled "How many".
      b.setAttribute('aria-label', n + ' ' + p + '% off each');
    });
  }
  function summary() {
    var c = cfg(); if (!c || c.mode === 'legacy' || !tiers().length) return;
    var q = $('.sv-qty'); if (!q) return;
    var el = $('#sv-mbsum');
    if (!el) {
      el = document.createElement('p'); el.id = 'sv-mbsum'; el.className = 'sv-mbsum'; el.setAttribute('aria-live', 'polite');
      q.parentNode.insertBefore(el, q.nextSibling);
    }
    var set = $('[data-set-on]');
    if (set && set.checked) { el.hidden = true; return; }   // the set box prices sets itself
    var rows = $$('.sv-item'), n = rows.length;
    if (!n) { el.hidden = true; return; }
    var pct = pctFor(n), list = 0, pay = 0;
    rows.forEach(function (r) { var pc = rowPrice(r); list += pc; pay += lineAfter(pc, pct); });
    var nx = nextTier(n);
    var what = c.handle && IDX ? (n === 1 ? 'item' : 'items') : (n === 1 ? 'item' : 'items');
    el.hidden = false;
    el.innerHTML = n === 1
      ? '<b>1 ' + what + ' ' + money(list) + '.</b> ' + (nx ? 'Add ' + (nx[0] - 1 === 1 ? 'one more' : (nx[0] - 1) + ' more') + ' for ' + nx[1] + '% off every one.' : '')
      : '<b>' + n + ' ' + what + ' ' + money(pay) + '</b>' + (pct ? ', you save ' + money(list - pay) + ' (' + pct + '% off each).' : '.') +
        (nx ? ' Add ' + (nx[0] - n === 1 ? 'one more' : (nx[0] - n) + ' more') + ' for ' + nx[1] + '% off every one.' : '') +
        (IDX ? ' Each one can have its own design.' : '');
  }

  function buildDesignMode(qty) {
    var c = cfg(); if (!c) return;
    var wrap = $('#sv-items'); if (!wrap) return;
    var keep = $$('.sv-item', wrap).map(function (el) {
      return {
        name: (el.querySelector('.sv-name') || {}).value || '',
        opts: $$('.sv-opt', el).map(function (s) { return s.value; }),
        face: (el.querySelector('.sv-face input:checked') || {}).value || '',
        d: el.__d || null, prod: el.__prod || null, partner: el.__partner || null
      };
    });
    var base = currentOptions();
    wrap.innerHTML = '';
    // COMPACT WHEN THERE IS MORE THAN ONE. A four person order was 4,350 px of scrolling on a phone,
    // about 1,100 px a person; the multi class tightens every row (sv-personalisation.liquid styles).
    wrap.classList.toggle('sv-items--multi', qty > 1);
    for (var i = 1; i <= qty; i++) {
      var prev = keep[i - 1] || {};
      var vars = (prev.prod && prev.prod.variants) || c.variants;
      var chosen = (prev.opts && prev.opts.length) ? prev.opts : base;
      var showOpts = qty > 1 && c.options.length > 0;
      var html =
        '<div class="sv-item" data-idx="' + i + '">' +
          (qty > 1 ? headHtml(i, qty, prev.d || (IDX && IDX.mine)) : '') +
          (showOpts ? '<div class="sv-optwrap">' + optionSelects(i, chosen, vars) + '</div>' : '') +
          '<div class="sv-namewrap">' +
            '<label class="sv-perso__lab" for="sv-name-' + i + '">Name to print <span class="sv-opt-note">optional</span> ' +
              '<span class="sv-perso__count"><span class="sv-cnt">0</span>/' + c.maxc + '</span></label>' +
            '<input id="sv-name-' + i + '" type="text" maxlength="' + c.maxc + '" class="sv-name" ' +
              (i === 1 ? 'name="properties[Name]" ' : '') +
              'placeholder="' + (qty > 1 ? 'Their name, or leave blank' : 'Type a name, or leave blank for the artwork on its own') +
              '" autocomplete="off" inputmode="text">' +
            '<p class="sv-err" hidden>Something went wrong adding this to the cart.</p>' +
          '</div>' +
          faceRow(i, c.font, qty > 1 && i > 1) +
          '<div class="sv-preview2' + (c.band ? '' : (c.art || prev.d ? '' : ' sv-preview2--nameonly')) + '">' +
            '<div class="sv-preview2__stage' + (c.band ? ' sv-preview2__stage--band' : '') +
                 '" data-slot="' + esc(prev.d ? (IDX && IDX.kind === 'c' ? 'above' : (prev.d[8] || c.slot)) : c.slot) + '" data-area="' + c.area + '">' +
            (c.band ?
              '<span class="sv-bpv">' +
                '<img class="sv-bpv__shot" alt="" decoding="async" fetchpriority="high">' +
                '<span class="sv-bpv__patch"></span>' +
                '<span class="sv-bpv__name" aria-live="polite"></span>' +
              '</span>' : '') +
              // Not lazy: this is the picture the shopper is looking at while
              // they type their name, so waiting for it to scroll into view is
              // exactly backwards.
              (c.band ? '' :
                ((c.art || prev.d) ? '<img class="sv-preview2__art" src="' + esc(prev.d ? img(prev.d[7] || prev.d[3], 900) : c.art) + '" alt="" ' +
                         'loading="eager" decoding="async" fetchpriority="low" width="900" height="900">' : '') +
                '<div class="sv-preview2__name" aria-live="polite"></div>') +
            '</div>' +
            '<p class="sv-preview2__cap">' +
              ((c.art || prev.d) ? 'Your print preview' : 'Your name, as it will be printed') +
            '</p>' +
          '</div>' +
        '</div>';
      var d = document.createElement('div');
      d.innerHTML = html;
      var node = d.firstElementChild;
      node.__d = prev.d; node.__prod = prev.prod; node.__partner = prev.partner;
      wrap.appendChild(node);
      if (prev.name) { node.querySelector('.sv-name').value = prev.name; }
      if (prev.face) {
        var fr = $$('.sv-face input', node).filter(function (r) { return r.value === prev.face; })[0];
        if (fr) fr.checked = true;
      }
      sync(node);
    }
    summary();
  }

  // The name is OPTIONAL: a blank one means the shopper wants the artwork on
  // its own, which is a real thing to want and is the same price. An empty
  // field must therefore add to cart cleanly, with NO Name property at all
  // rather than an empty one, so the printer is never handed a blank to set.
  // THE PREVIEW.
  // The product photo carries a SAMPLE name baked into it - a shopper who typed
  // "Barry" was still looking at "POPPY", which is the complaint that produced
  // this. The second product image is now rendered with NO name on it, so the
  // real name can be laid over it here in the same ink and the same face the
  // press uses. 'hero' sets the name under the art, 'above' over it, exactly as
  // tools/personalise.py composes the print master.
  // The row's own variant, resolved the same way the cart build resolves it, so
  // the preview cannot show one bandana and the cart add another.
  function rowVariantId(node) {
    var vars = rowVars(node);
    var sels = $$('.sv-opt', node);
    if (sels.length) {
      var hit = resolve(sels.map(function (s) { return s.value; }), vars);
      if (hit) return String(hit.id);
    }
    // A row on another design has no page variant to fall back on: take the same options, or its first available.
    if (node && node.__prod) {
      var same = resolve(currentOptions(), vars) || vars.filter(function (v) { return v.available; })[0] || vars[0];
      return same ? String(same.id) : '';
    }
    return currentVariantId();
  }

  function drawBand(node, c) {
    var wrap = node.querySelector('.sv-bpv'); if (!wrap) return;
    var shot = wrap.querySelector('.sv-bpv__shot');
    var patch = wrap.querySelector('.sv-bpv__patch');
    var el = wrap.querySelector('.sv-bpv__name');
    var input = node.querySelector('.sv-name');
    if (!shot || !patch || !el || !input) return;
    var b = bandFor(c, rowVariantId(node), rowVars(node));
    if (!b) return;
    if (b.shot && shot.getAttribute('src') !== b.shot) shot.setAttribute('src', b.shot);
    shot.setAttribute('alt', 'Your ' + b.colour.toLowerCase() + ' bandana, ' +
                             (b.tag === 'collar' ? 'collar style' : 'tie-on style'));

    // The patch is a window onto the blank at the SAME place, so the fabric's own
    // shading carries straight through and no join shows. Sized and positioned as
    // percentages, which is what keeps it exact at any width.
    var n = b.cal.name, pad = 0.012;
    var x0 = Math.max(0, n.x0 - pad), y0 = Math.max(0, n.y0 - pad);
    var w = Math.min(1, n.x1 + pad) - x0, h = Math.min(1, n.y1 + pad) - y0;
    patch.style.left = (x0 * 100) + '%';
    patch.style.top = (y0 * 100) + '%';
    patch.style.width = (w * 100) + '%';
    patch.style.height = (h * 100) + '%';
    patch.style.backgroundImage = 'url("' + b.blank + '")';
    patch.style.backgroundSize = (100 / w) + '% ' + (100 / h) + '%';
    patch.style.backgroundPosition = (w < 1 ? x0 / (1 - w) * 100 : 0) + '% ' +
                                     (h < 1 ? y0 / (1 - h) * 100 : 0) + '%';

    el.style.left = (n.x0 * 100) + '%';
    el.style.top = (n.y0 * 100) + '%';
    el.style.width = ((n.x1 - n.x0) * 100) + '%';
    el.style.height = ((n.y1 - n.y0) * 100) + '%';
    var v = (input.value || '').trim();
    el.textContent = v;
    el.style.color = rowInk(node);
    var chosen = faceFor(node);
    el.style.fontFamily = '"' + ((chosen && chosen.css) || c.font) +
      '", "Luckiest Guy", Impact, sans-serif';
    wrap.classList.toggle('is-empty', !v);
    if (!v) return;
    // Fit the name into the band the press prints it in: start from the band's
    // height and shrink until it fits its width, the way _fit_font does.
    var bw = wrap.clientWidth * (n.x1 - n.x0);
    var bh = wrap.clientHeight * (n.y1 - n.y0);
    if (!bw || !bh) return;
    var size = Math.round(bh * 0.86);
    el.style.fontSize = size + 'px';
    el.style.setProperty('--sv-ring', Math.max(1, Math.round(size * 0.09)) + 'px');
    var guard = 0;
    while (el.scrollWidth > bw && size > 7 && guard++ < 80) {
      size -= 1;
      el.style.fontSize = size + 'px';
      el.style.setProperty('--sv-ring', Math.max(1, Math.round(size * 0.09)) + 'px');
    }
  }

  function drawPreview(node) {
    var c = cfg(); if (!c) return;
    if (c.band) return drawBand(node, c);
    var stage = node.querySelector('.sv-preview2__stage');
    var el = node.querySelector('.sv-preview2__name');
    var input = node.querySelector('.sv-name');
    if (!stage || !el || !input) return;
    var v = (input.value || '').trim();
    el.textContent = v;
    el.style.color = rowInk(node);
    var chosen = faceFor(node);
    el.style.fontFamily = '"' + ((chosen && chosen.css) || c.font) +
      '", "Luckiest Guy", Impact, sans-serif';
    stage.classList.toggle('is-empty', !v);
    if (!v) return;
    // Fit the name to the stage width the way _fit_font does: shrink until it
    // fits, never let it touch the edge (the renderer keeps 2.5% of air).
    var box = stage.clientWidth * 0.95;
    if (!box) return;
    var round = (c.area === 'ornament');
    var size = Math.round(stage.clientHeight *
                          (round ? 0.155 : (rowSlot(node) === 'above' ? 0.15 : 0.19)));
    // Inside a circle the usable width is the chord, not the diameter. The name
    // band sits low, where the chord is about 0.74 of the width, and the render
    // keeps air inside that.
    if (round) { box = stage.clientWidth * 0.70; }
    el.style.fontSize = size + 'px';
    var guard = 0;
    while (el.scrollWidth > box && size > 9 && guard++ < 60) {
      size -= 1;
      el.style.fontSize = size + 'px';
    }
  }

  // A face change is a change to what gets printed, so it redraws immediately
  // rather than waiting for the next keystroke.
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.name && t.name.indexOf('sv-face-') === 0) {
      var node = t.closest('.sv-item');
      if (node) sync(node);
    }
  });

  function sync(node) {
    var n = node.querySelector('.sv-name');
    var cnt = node.querySelector('.sv-cnt');
    var echo = node.querySelector('.sv-echo__t');
    var v = (n && n.value || '').trim();
    if (cnt && n) cnt.textContent = String((n.value || '').length);
    if (echo) echo.textContent = v || '';
    drawPreview(node);
  }

  /* ---------- legacy design-family mode keeps its own template ---------- */

  function buildLegacy(qty) {
    var wrap = $('#sv-items'), tpl = $('#sv-item-tpl');
    if (!wrap || !tpl) return;
    var c = cfg();
    var keep = {};
    $$('.sv-item', wrap).forEach(function (el) {
      keep[el.getAttribute('data-idx')] = {
        d: (el.querySelector('input[type=radio]:checked') || {}).value,
        r: (el.querySelector('.sv-role') || {}).value,
        s: (el.querySelector('.sv-surname') || {}).value,
        n: (el.querySelector('.sv-name') || {}).value
      };
    });
    wrap.innerHTML = '';
    for (var i = 1; i <= qty; i++) {
      var html = tpl.innerHTML
        .split('__ITEM__').join('Item ' + i)
        .split('__N__').join(String(i))
        .split('__MAX__').join(String(c.maxc));
      var d = document.createElement('div');
      d.innerHTML = html;
      var node = d.firstElementChild;
      $$('input[type=radio]', node).forEach(function (r) { r.name = 'sv-design-' + i; });
      var cp = node.querySelector('.sv-item__copy');
      if (i === 1 && cp) cp.style.display = 'none';
      wrap.appendChild(node);
      var k = keep[String(i)];
      if (k) {
        if (k.d) { var m = $$('input[type=radio]', node).filter(function (r) { return r.value === k.d; })[0]; if (m) m.checked = true; }
        ['sv-role', 'sv-surname', 'sv-name'].forEach(function (cl, ix) {
          var t = node.querySelector('.' + cl); var val = [k.r, k.s, k.n][ix];
          if (t && val) t.value = val;
        });
      }
      syncLegacy(node);
    }
    renderPreviews();
  }

  function syncLegacy(node) {
    var c = node.querySelector('input[type=radio]:checked');
    var fam = c && c.closest('.sv-dsw').getAttribute('data-family') === '1';
    var rw = node.querySelector('.sv-rolewrap'), nw = node.querySelector('.sv-namewrap');
    if (rw) rw.style.display = fam ? 'block' : 'none';
    if (nw) nw.style.display = fam ? 'none' : 'block';
    var n = node.querySelector('.sv-name'), cnt = node.querySelector('.sv-cnt');
    if (cnt && n) cnt.textContent = String((n.value || '').length);
  }

  function renderPreviews() {
    if (!window.SVPreview) return;
    $$('.sv-item').forEach(function (node) {
      var box = node.querySelector('.sv-pbox'); if (!box) return;
      var c = node.querySelector('input[type=radio]:checked');
      var key = c ? c.value : 'Santa Hat Badge';
      var fam = c && c.closest('.sv-dsw').getAttribute('data-family') === '1';
      box.innerHTML = fam
        ? (window.SVPreview(key, (node.querySelector('.sv-role') || {}).value || 'Mum',
            ((node.querySelector('.sv-surname') || {}).value || '').trim()) || '')
        : (window.SVPreview(key, ((node.querySelector('.sv-name') || {}).value || '').trim() || 'Your name', '') || '');
    });
  }

  /* ---------- collect + submit ---------- */

  // A product page carries MORE than one add-to-cart form: every product card
  // in the recommendations strip ships its own quick-add form. querySelector
  // took whichever came first in the DOM, which on some templates is a card,
  // not the product - so the variant id, the submit binding and the on:submit
  // removal were all being applied to the wrong form. The main buy-buttons
  // form is the one Horizon names BuyButtons-ProductForm-<section id>.
  function form() {
    var el = root();
    if (el) {
      var scope = el.closest('.shopify-section, product-information, [id^="shopify-section"]');
      var f = scope && scope.querySelector('form[id^="BuyButtons-ProductForm"][action*="/cart/add"]');
      if (f) return f;
    }
    return $('form[id^="BuyButtons-ProductForm"][action*="/cart/add"]') ||
           $('form[action*="/cart/add"]');
  }

  function submitter() {
    var f = form();
    return f && (f.querySelector('button[type="submit"]') || f.querySelector('.add-to-cart-button'));
  }

  function collect() {
    var c = cfg(); if (!c) return { lines: [], bad: null };
    var lines = [], bad = null, partners = [];
    $$('.sv-item').forEach(function (node) {
      var props = {};
      var vid = currentVariantId();

      if (c.mode === 'legacy') {
        var r = node.querySelector('input[type=radio]:checked');
        var fam = r && r.closest('.sv-dsw').getAttribute('data-family') === '1';
        if (r) props['Design'] = r.value;
        if (fam) {
          var role = (node.querySelector('.sv-role') || {}).value || '';
          var sur = ((node.querySelector('.sv-surname') || {}).value || '').trim();
          if (role) props['Name'] = role;
          if (sur) props['Family name'] = sur;
        } else {
          var nm = ((node.querySelector('.sv-name') || {}).value || '').trim();
          if (!nm && c.required) { bad = bad || node; return; }
          if (nm) props['Name'] = nm;
        }
      } else {
        vid = rowVariantId(node) || vid;
        var name = ((node.querySelector('.sv-name') || {}).value || '').trim();
        if (!name && c.required) { bad = bad || node; return; }
        if (name) {
          props['Name'] = name;
          // Only when there IS a name: "Lettering: Script" against a blank name
          // is noise on a packing slip for an item printed with no name at all.
          var fc = faceFor(node);
          if (fc) props['Lettering'] = fc.key;
        }
      }
      var gcf = window.SVGarment && window.SVGarment.cfg;
      if (gcf && c.mode !== 'legacy') {
        var gvar = rowVars(node).filter(function (v) { return String(v.id) === String(vid); })[0];
        var gnames = (c.options || []).map(function (o) { return o.name || o; });
        var gvals = gvar ? (gvar.options || [gvar.option1, gvar.option2, gvar.option3]) : [];
        var gsi = gnames.indexOf('Style'), gci = gnames.indexOf('Colour');
        var gfc = faceFor(node);
        props['_sv_preview'] = JSON.stringify({
          m: gcf.manifest, s: (gsi >= 0 && gvals[gsi]) || gcf.style, c: (gci >= 0 && gvals[gci]) || gcf.colour,
          a: node.__d ? img(node.__d[7] || node.__d[3], 900) : gcf.art, n: props['Name'] || '',
          i: node.__d ? (node.__d[9] || gcf.ink) : gcf.ink,
          f: gfc ? '"' + gfc.css + '"' : gcf.font, k: gfc ? gfc.caps : gcf.caps,
          l: node.__d ? (node.__d[8] || gcf.slot) : gcf.slot
        });
      }
      lines.push({ id: vid, quantity: 1, properties: props });
      partners.push(node.__d ? (node.__partner || 'x') : '');
    });
    return { lines: lines, bad: bad, partners: partners };
  }

  function showError(node) {
    $$('.sv-err').forEach(function (e) { e.hidden = true; });
    var e = node && node.querySelector('.sv-err');
    if (e) e.hidden = false;
    var i = node && node.querySelector('.sv-name');
    if (i) { i.focus(); i.scrollIntoView({ block: 'center', behavior: 'smooth' }); }
  }

  function fire(lines) {
    var resolveFn, p = new Promise(function (r) { resolveFn = r; });
    var ev = new Event(EVT, { bubbles: true, cancelable: false });
    ev.action = 'add';
    ev.context = 'product';
    ev.lines = lines.map(function (l) {
      return { merchandiseId: 'gid://shopify/ProductVariant/' + l.id, quantity: l.quantity };
    });
    ev.promise = p;
    (form() || document).dispatchEvent(ev);
    return resolveFn;
  }

  function submit(e) {
    // A PHOTO PRODUCT POSTS NATIVELY. This file intercepts the submit and posts
    // JSON to /cart/add.js, and JSON cannot carry a file. Shopify's line item
    // file upload needs a real multipart form post, so on a product carrying an
    // uploader sv-photo.js marks the form and this stands aside. One photo, one
    // item: multiple names on one line cannot carry multiple files anyway.
    var fm = e && e.target && e.target.closest ? e.target.closest('form') : null;
    if ((fm && fm.getAttribute('data-sv-native')) ||
        document.querySelector('form[data-sv-native]')) return;
    var c = cfg(); if (!c) return;
    var got = collect();
    // ORDER MATTERS HERE. The empty-lines check used to run first, and a
    // single item with no name produces exactly that: zero lines and a `bad`
    // node. Returning without preventDefault let the native submit through, so
    // an unnamed personalised sack went into the cart with no name on it.
    // The failed-validation case is checked before the nothing-to-do case.
    if (got.bad) { e.preventDefault(); e.stopImmediatePropagation(); showError(got.bad); return; }
    if (!got.lines.length) { e.preventDefault(); e.stopImmediatePropagation(); return; }
    // 0.31.0: a ticked "make it a set" (sv-set.js) adds the matching sack or stocking after every line.
    if (window.SVSet && window.SVSet.expand) {
      var sx = window.SVSet.expand(got.lines);
      if (sx && sx.error) { e.preventDefault(); e.stopImmediatePropagation(); return; }
      if (sx && sx.lines) {
        // A row on another design takes THAT design's matching piece, not this page's.
        // 'x' is a row whose design has no matching piece (or it is still loading): never pair it with this
        // page's piece, which would be a different design; that row goes in on its own.
        if (sx.lines.length === 2 * got.lines.length) {
          var drop = {};
          (got.partners || []).forEach(function (pid, i) {
            if (pid === 'x') drop[2 * i + 1] = true;
            else if (pid) sx.lines[2 * i + 1].id = pid;
          });
          sx.lines = sx.lines.filter(function (l, i) { return !drop[i]; });
        }
        got.lines = sx.lines;
      }
    }

    e.preventDefault();
    e.stopImmediatePropagation();
    $$('.sv-err').forEach(function (x) { x.hidden = true; });

    var btn = submitter();
    if (btn) btn.setAttribute('aria-busy', 'true');

    var settle = fire(got.lines);

    fetch((window.Theme && window.Theme.routes && window.Theme.routes.cart_add_url) || '/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: got.lines })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (btn) btn.removeAttribute('aria-busy');
        if (!res.ok) {
          settle({ detail: { didError: true } });
          var msg = (res.j && (res.j.description || res.j.message)) || 'Could not add to cart.';
          var e1 = $('.sv-err'); if (e1) { e1.textContent = msg; e1.hidden = false; }
          return;
        }
        settle({ detail: { didError: false } });
        // If the theme did not open a drawer within a beat, the cart page is
        // the honest fallback - never leave the shopper unsure it worked.
        setTimeout(function () {
          if (!document.querySelector('cart-drawer-component dialog[open], dialog[open] cart-drawer-component')) {
            window.location.href = '/cart';
          }
        }, 700);
      })
      .catch(function () {
        if (btn) btn.removeAttribute('aria-busy');
        settle({ detail: { didError: true } });
        window.location.href = '/cart';
      });
  }

  /* ---------- wiring ---------- */

  function build(q) {
    var c = cfg(); if (!c) return;
    if (c.mode === 'legacy') buildLegacy(q); else buildDesignMode(q);
    var qi = $('.quantity__input, input[name="quantity"]');
    if (qi) { qi.value = 1; }
  }

  function bind() {
    var c = cfg(); if (!c) return;
    var qwrap = $('.sv-qty');
    if (qwrap && !qwrap.__svBound) {
      qwrap.__svBound = true;
      qwrap.addEventListener('click', function (e) {
        var b = e.target.closest('.sv-qty__b'); if (!b) return;
        $$('.sv-qty__b').forEach(function (x) {
          x.classList.remove('is-on');
          x.setAttribute('aria-pressed', 'false');
        });
        b.classList.add('is-on');
        b.setAttribute('aria-pressed', 'true');
        var live = $('#sv-items');
        if (live) live.setAttribute('aria-label', b.getAttribute('data-q') + ' items to personalise');
        build(parseInt(b.getAttribute('data-q'), 10) || 1);
      });
    }
    if (!document.__svVariant) {
      document.__svVariant = true;
      // THE MAIN VARIANT PICKER IS OUTSIDE .sv-item, so onAny below never saw it
      // and the preview sat on whatever it was first drawn with. Picking a colour
      // or a style has to redraw every row.
      var redraw = function () {
        var c = cfg(); if (!c || !c.band) return;
        $$('.sv-item').forEach(function (n) { drawBand(n, c); });
      };
      // The picker does not update the form's variant id synchronously, so a
      // fixed delay redrew the PREVIOUS selection and the preview ran one click
      // behind. Watch the id instead and draw when it actually moves, with a
      // bounded poll so a theme change cannot leave this waiting forever.
      var watching = 0;
      var watch = function () {
        var was = currentVariantId();
        var tries = 0;
        clearInterval(watching);
        watching = setInterval(function () {
          var now = currentVariantId();
          if (now !== was) { was = now; redraw(); }
          if (++tries > 24) { clearInterval(watching); redraw(); }
        }, 70);
      };
      document.addEventListener('change', function (e) {
        if (e.target && e.target.closest && e.target.closest('.sv-item')) return;
        watch();
      }, true);
      document.addEventListener('click', function (e) {
        if (e.target && e.target.closest && e.target.closest('.sv-item')) return;
        if (e.target.closest && e.target.closest('.variant-picker__form, variant-picker-component, .product-form, swatches-variant-picker-component')) watch();
      }, true);
    }
    if (!document.__svInput) {
      document.__svInput = true;
      document.addEventListener('input', onAny);
      document.addEventListener('change', onAny);
      document.addEventListener('click', function (e) {
        var cp = e.target.closest && e.target.closest('.sv-item__copy');
        if (cp) { e.preventDefault(); copyFirst(cp.getAttribute('data-copy')); }
        var ch = e.target.closest && e.target.closest('.sv-item__chg');
        if (ch) { e.preventDefault(); openPicker(ch.closest('.sv-item')); }
      });
    }
    // TWO CONTROLS ON A PERSONALISED PAGE CAN TAKE MONEY WITHOUT A NAME.
    //
    // 1. THE ACCELERATED CHECKOUT (Shop Pay / Buy it now). It does not submit
    //    the product form - it navigates straight to checkout with the variant
    //    id - so the submit interception below never sees it and no
    //    properties[Name] is ever written. On mobile it is the most prominent
    //    and most habitual button on the page. A shopper taps it, pays $59.95
    //    for a personalised tee, and receives the artwork with no name on it.
    //    There is no error and no warning, so the store finds out when the
    //    customer does. It is removed from personalised products; it stays on
    //    stocked ones, where it is doing its job.
    //
    // 2. THE NATIVE QUANTITY STEPPER. build() forces it back to 1 and collect()
    //    never reads it, so a shopper who picks the "3" chip and then steps the
    //    native field to 3 gets three items, not nine - and one who ignores the
    //    chips and steps the native field to 4 gets one. Silently. On a store
    //    whose whole AOV model is four to six matching items, the control they
    //    will instinctively reach for is inert.
    if (root()) {
      var f1 = form();
      var scope = f1 ? (f1.closest('product-form-component') || f1.parentElement) : null;
      if (scope) {
        var acc = scope.querySelectorAll(
          '.accelerated-checkout-block, shopify-accelerated-checkout, ' +
          'shopify-accelerated-checkout-cart, [data-shopify="payment-button"]');
        for (var i = 0; i < acc.length; i++) acc[i].remove();

        var qty = scope.querySelectorAll('quantity-selector-component, .quantity-selector, ' +
                                         '.product-form__quantity');
        for (var j = 0; j < qty.length; j++) qty[j].remove();
      }
    }

    // WHY HORIZON'S OWN HANDLER IS DISCONNECTED RATHER THAN OUT-RACED.
    // Horizon's component runtime registers ONE delegated capture listener on
    // document per event type, at module evaluation, and resolves the handler
    // with target.closest('[on:submit]'). It registers before any deferred
    // script, so it always runs first and stopImmediatePropagation() from our
    // listener is too late - which is how a two name order produced THREE
    // lines: our two correct ones plus Horizon's own quantity-1,
    // no-properties line on top.
    //
    // The attribute is NOT on the <form>. It is on the <product-form-component>
    // wrapper, which is why removing it from the form changed nothing. Taken
    // off the wrapper, closest() returns null, the handler never resolves, and
    // ours is the only one that runs.
    var f0 = form();
    var host = f0 && f0.closest('product-form-component');
    if (host) {
      if (root() && host.hasAttribute('on:submit')) {
        host.setAttribute('data-sv-onsubmit', host.getAttribute('on:submit'));
        host.removeAttribute('on:submit');
      } else if (!root() && host.hasAttribute('data-sv-onsubmit')) {
        host.setAttribute('on:submit', host.getAttribute('data-sv-onsubmit'));
        host.removeAttribute('data-sv-onsubmit');
      }
    }

    // WHY THE LISTENER IS ON document AND NOT ON THE FORM.
    // Bound to the form, this lost the race: at the target element listeners
    // run in REGISTRATION order whether or not they asked for capture, and
    // Horizon's <product-form-component> registers first. The add went through
    // its handler instead, which posts the form's own FormData - one line item,
    // no properties at all. A capture listener on document runs before any
    // listener further down the tree, every time.
    if (!document.__svSubmit) {
      document.__svSubmit = true;
      document.addEventListener('submit', function (e) {
        var t = e.target;
        if (!t || !t.matches || !t.matches('form[action*="/cart/add"]')) return;
        if (!root()) return;
        if (t !== form()) return;       // a quick-add card, not this product
        submit(e);
      }, true);
    }
    if ($('#sv-items')) build(1);
    if (c.mode !== 'legacy') {
      labelQty();
      summary();
      loadIndex().then(function () { $$('.sv-item').forEach(refreshHead); summary(); });
      if (!document.__svSetSum) {
        document.__svSetSum = true;
        document.addEventListener('change', function (e) { if (e.target && e.target.matches && e.target.matches('[data-set-on]')) summary(); });
      }
    }
  }

  function onAny(e) {
    var node = e.target.closest && e.target.closest('.sv-item');
    if (!node) return;
    var c = cfg();
    if (c && c.mode === 'legacy') { if (e.target.type === 'radio') syncLegacy(node); renderPreviews(); }
    else { sync(node); if (e.target.classList && e.target.classList.contains('sv-opt')) summary(); }
    var err = node.querySelector('.sv-err');
    if (err && e.target.classList.contains('sv-name') && e.target.value.trim()) err.hidden = true;
  }

  function copyFirst(idx) {
    var items = $$('.sv-item'); if (items.length < 2) return;
    var a = items[0], b = items.filter(function (x) { return x.getAttribute('data-idx') === String(idx); })[0];
    if (!a || !b) return;
    var d = (a.querySelector('input[type=radio]:checked') || {}).value;
    if (d) { var m = $$('input[type=radio]', b).filter(function (r) { return r.value === d; })[0]; if (m) m.checked = true; }
    ['sv-role', 'sv-surname', 'sv-name'].forEach(function (cl) {
      var s = a.querySelector('.' + cl), t = b.querySelector('.' + cl);
      if (s && t) t.value = s.value;
    });
    var c = cfg();
    var copyRest = function () {
      $$('.sv-opt', a).forEach(function (s, i) {
        var t = $$('.sv-opt', b)[i]; if (t) t.value = s.value;
      });
      var fa = a.querySelector('.sv-face input:checked');
      if (fa) { var fb = $$('.sv-face input', b).filter(function (r) { return r.value === fa.value; })[0]; if (fb) fb.checked = true; }
      if (c && c.mode === 'legacy') { syncLegacy(b); renderPreviews(); } else { sync(b); summary(); }
    };
    // Same as item 1 means the same design too, so a set of four can be one design with four names.
    if (c && c.mode !== 'legacy' && IDX && (a.__d || null) !== (b.__d || null)) {
      setRowDesign(b, a.__d || IDX.mine).then(copyRest);
    } else copyRest();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind);
  else bind();
  document.addEventListener('shopify:section:load', bind);
})();
